import { PROJECT_TEMPLATES_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getTemplateCategoryLoading: false,
    getTemplateCategorySuccess: false,
    getTemplateCategoryFailure: false,
    getTemplateCategoryError: null,
    getTemplateCategory: [],
    getTemplateBoardLoading: false,
    getTemplateBoardSuccess: false,
    getTemplateBoardFailure: false,
    getTemplateBoardError: null,
    getTemplateBoard: [],

}

export const projectTemplateReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_REQUEST:
            return {
                ...state,
                getTemplateBoardLoading: true,
                getTemplateBoardSuccess: false,
                getTemplateBoardFailure: false,
                getTemplateBoardError: null,
                getTemplateBoard: [],
            }
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_SUCCESS:
            let list = action.payload
            for (let i = 0; i < action.payload.length; i++) {
                list[i].cards = list[i].cards ? list[i].cards : []
            }
            return {
                ...state,
                getTemplateBoardLoading: false,
                getTemplateBoardSuccess: true,
                getTemplateBoardFailure: false,
                getTemplateBoardError: null,
                getTemplateBoard: list,
            }
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BOARD_FAILURE:
            return {
                ...state,
                getTemplateBoardLoading: false,
                getTemplateBoardSuccess: false,
                getTemplateBoardFailure: true,
                getTemplateBoardError: action.payload,
                getTemplateBoard: [],
            }
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_REQUEST:
            return {
                ...state,
                getTemplateCategoryLoading: true,
                getTemplateCategorySuccess: false,
                getTemplateCategoryFailure: false,
                getTemplateCategoryError: null,
                getTemplateCategory: [],
            }
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_SUCCESS:
            return {
                ...state,
                getTemplateCategoryLoading: false,
                getTemplateCategorySuccess: true,
                getTemplateCategoryFailure: false,
                getTemplateCategoryError: null,
                getTemplateCategory: action.payload,
            }
        case PROJECT_TEMPLATES_REQUEST.GET_TEMPLATE_BYID_FAILURE:
            return {
                ...state,
                getTemplateCategoryLoading: false,
                getTemplateCategorySuccess: false,
                getTemplateCategoryFailure: true,
                getTemplateCategoryError: action.payload,
                getTemplateCategory: [],
            }
        default:
            return state
    }
}